module.exports = __webpack_public_path__ + "img/sjiek.09717fa2.jpg";